import { Input } from '@bpinternal/ui-kit-next'
import { Search, LayoutList, LayoutGrid } from 'lucide-react'
import { SortDropdown } from './SortDropdown'
import { SortType } from '../hooks/useBotSort'

type BotListToolbarProps = {
  filter: string
  onFilterChange: (filter: string) => void
  sortType: SortType
  onSortTypeChange: (sortType: SortType) => void
  viewMode: 'grid' | 'list'
  onViewModeChange: (viewMode: 'grid' | 'list') => void
}

export const BotsToolbar = ({
  filter,
  onFilterChange,
  sortType,
  onSortTypeChange,
  viewMode,
  onViewModeChange,
}: BotListToolbarProps) => {
  return (
    <div className="flex w-full gap-2 pb-2">
      <div className="relative min-w-0 flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search"
          value={filter}
          onChange={(e) => onFilterChange(e.target.value)}
          className="h-9 pl-10"
        />
      </div>

      <div className="flex-shrink-0">
        <SortDropdown sortType={sortType} onSortTypeChange={onSortTypeChange} />
      </div>

      <div className="hidden h-9 w-16 flex-shrink-0 rounded-lg border border-border bg-background p-1 lg:flex">
        <ViewModeButton
          isSelected={viewMode === 'grid'}
          buttonViewMode="grid"
          onViewModeChange={onViewModeChange}
          icon={<LayoutGrid className="h-4 w-4" />}
        />
        <ViewModeButton
          isSelected={viewMode === 'list'}
          buttonViewMode="list"
          onViewModeChange={onViewModeChange}
          icon={<LayoutList className="h-4 w-4" />}
        />
      </div>
    </div>
  )
}

const ViewModeButton = ({
  isSelected,
  buttonViewMode,
  onViewModeChange,
  icon,
}: {
  isSelected: boolean
  buttonViewMode: 'grid' | 'list'
  onViewModeChange: (viewMode: 'grid' | 'list') => void
  icon: React.ReactNode
}) => {
  return (
    <button
      className={`flex flex-1 items-center justify-center rounded-sm text-sm transition-colors duration-200 ${
        isSelected ? 'bg-gray-3 text-foreground' : 'text-muted-foreground hover:text-foreground'
      }`}
      onClick={() => onViewModeChange(buttonViewMode)}
    >
      {icon}
    </button>
  )
}
